'use strict';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

export default class Lightbox {
	constructor() {
		this.init();
	}

	init() {
		// rotation-drive images lightbox
		const photo_swipe_options = {
			gallery: '[data-photo-swipe-lightbox]',
			pswpModule: PhotoSwipe,
			// set background opacity
			bgOpacity: 1,
			showHideOpacity: true,
			children: 'a',
			loop: false,
			showHideAnimationType: 'zoom', /* options: fade, zoom, none */
			/* Click on image moves to the next slide */
			imageClickAction: 'next',
			tapAction: 'next',
			/* ## Hiding a specific UI element ## */
			zoom: false,
			close: true,
			counter: true,
			arrowKeys: true,
			bgOpacity: "1",/* deafult: 0.8 */
			wheelToZoom: true, /* deafult: undefined */
		};

		const rotateLightbox = new PhotoSwipeLightbox(photo_swipe_options);
		rotateLightbox.init();
	}
}